export default {
  en: {
    hints: {
      rooftop: 'Tap to choose chapter',
      chapter: 'Tap to go to next item'
    },
    devicemessage: 'Please view this website on a larger screen.',
    cursor: {
      click: 'Click',
      toEnter: 'to enter',
      'double-dutch': 'Double Dutch',
      'extremes': 'Extremes',
      'the-end': 'The end',
      'what': 'What',
      'when': 'When',
      'where': 'Where',
      'who': 'Who',
      'why': 'Why',
      'back': 'Back',
      'next': 'Next',
      'back to start': 'Back to start'
    },
    turn: 'Please rotate your device for optimal display.',
    compatibility: 'This project makes use of modern web technologies. Please use a different device or browser. We recommend Google Chrome.',
    intro: {
      watch: 'Watch intro',
      skip: 'Skip intro'
    },
    slideout: {
      intro: 'Introduction',
      colofon: {
        title: 'Colophon',
        body: `
         <p><strong>Apartheid was a system enforcing hatred and racism by law. How did it work? Who were behind it? How did human destruction look like? When and where did it happen and how did it come to an end?</strong></p>
         <p><strong>Apartheid Revisited explores the whereabouts of white oppression in South Africa, its European/Dutch roots and the relevance of an 'old' story for today. With divisions between people – walls, borders, exclusion, restrictions – omnipresent the question is: is Apartheid history?</strong></p>
         <p>This project is initiated and designed by Ruiter Janssen.</p>
         <p>Realisation: Studio Ruiter Janssen, ZAM magazine, Afdeling Buitengewone Zaken.</p>
         <p>Thanks to Natasja van Heusden (proofreading), Milan Hermes (photo credits), Sjoerd Knibbeler (photography in white space), Luuk Schipperheyn (development A/BZ), Jeroen Loonuys (sounddesign trailer), Cornelia Knoll and the District 6 Museum (Cape Town) for their assistance in the production of our main visual.</p>
         <p>Questions and comments: info@zammagazine.com</p>
         <p>Disclaimer. We have done all we could to establish copyrights of visuals in this application. If you find your content is used incorrectly please contact us at info@zammagazine.com Any infringement was not done on purpose and will be rectified to all parties satisfaction.</p>
         <p>This project was realised with the financial support of the Creative Industries Fund, the Netherlands</p>
        `
      }
    }
  },
  nl: {
    hints: {
      rooftop: 'Raak aan om hoofdstuk te kiezen',
      chapter: 'Raak aan voor het volgende onderdeel'
    },
    devicemessage: 'Bekijk deze website op een groter scherm.',
    cursor: {
      click: 'Klik',
      toEnter: 'voor',
      'double-dutch': 'Double Dutch',
      'extremes': 'Extremen',
      'the-end': 'Het einde?',
      'what': 'Wat',
      'when': 'Wanneer',
      'where': 'Waar',
      'who': 'Wie',
      'why': 'Waarom',
      'back': 'Terug',
      'next': 'Volgende',
      'back to start': 'Terug naar begin'
    },
    turn: 'Draai uw apparaat in horizontale stand om deze site te bekijken.',
    compatibility: 'Dit project maakt gebruik van moderne webtechnologieën. Gebruik aub een andere browser. Wij raden Google Chrome aan.',
    intro: {
      watch: 'Bekijk intro',
      skip: 'Sla intro over'
    },
    slideout: {
      intro: 'Introductie',
      colofon: {
        title: 'Colofon',
        body: `
         <p><strong>Apartheid was een duivels systeem dat tot haat en racisme verplichtte. Hoe ging dat? Wie zaten erachter? Hoe ziet menselijke vernietiging eruit? Wanneer en waar stak het zijn kop op en hoe kwam het ten val? </strong></p>
         <p><strong>Apartheid Revisited onderzoekt de achtergronden van witte onderdrukking in Zuid-Afrika, haar Nederlandse en Europese wortels en de relevantie van dit geschiedenisverhaal voor vandaag. Scheiding van mensen – muren, grenzen, uitsluiting, bewegingsbeperkingen – is aan de orde van de dag. Is apartheid wel geschiedenis?</strong></p>
         <p>Dit project is een initiatief van Ruiter Janssen.</p>
         <p>Realisatie: Studio Ruiter Janssen, ZAM magazine, Afdeling Buitengewone Zaken.</p>
         <p>Met dank aan Natasja van Heusden (proofreading) en Milan Hermes (fotocredits), Sjoerd Knibbeler (fotografie in white space), Luuk Schipperheyn (development A/BZ), Jeroen Loonuys (sounddesign trailer), Cornelia Knoll en het District 6 Museum (Kaapstad) voor hun assistentie in de productie van het hoofdbeeld.</p>
         <p>Vragen  en opmerkingen: info@zammagazine.com</p>
         <p>Disclaimer. Wij hebben alles in het werk gesteld om vast te stellen of voor beelden in deze applicatie copyrights verschuldigd zijn. Als wij rechten over het hoofd hebben gezien, verzoeken wij u ons daarover te informeren  via info@zammagazine.com Onze excuses als er sprake is van enige inbreuk.</p>
         <p>Dit project kwam tot stand met steun van het Stimuleringsfonds Creatieve Industrie.</p>
        `
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/languageConf.js